import axios from 'axios';
import {backendHost} from '../../config';

export const getRoleById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/roles/${params.id}`, {params});
};